<template>
  <div
    class="modal fade bs-example-modal-lg sync-in-progress"
    id="sync-tmp-change-modal"
    aria-hidden="true"
    aria-labelledby="exampleGrid"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-simple modal-center">
      <div class="modal-content">
        <div class="modal-body modal-padding">
          <div class="row">
            <div class="col-sm-12 text-align-center form-content">
              <h4 class="modal-title">
                {{ $t("home.sync_tmp_change_modal_title") }}
              </h4>
              <br />
              <div class="col-md-12">
                <p>{{ $t("home.sync_tmp_change_modal") }}</p>
              </div>
              <div class="text-center mt-50">
                <button
                  class="btn waves-effect waves-classic btn-red"
                  type="button"
                  @click.prevent="gotoRentals()"
                >
                  {{ $t("home.goto_rentals_menu") }}
                </button>
                <button
                  class="btn waves-effect waves-classic ml-10"
                  type="button"
                  @click.prevent="closeModal('#sync-tmp-change-modal')"
                >
                  {{ $t("button.close") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from "../../mixins/mixin";

export default {
  name: "modal",
  mixins: [mixin],
  methods: {
    gotoRentals() {
      this.closeModal("#sync-tmp-change-modal"),
        (window.location.href = window.location.origin + "/#/rentals");
    },
  },
};
</script>



// WEBPACK FOOTER //
// modal.vue?da8540dc